// extracted by mini-css-extract-plugin
export default {"tableRow":"roleList_tableRow__mHqJu","tableCell":"roleList_tableCell__pEwCR"};